import React from "react";
import { SynapticText } from "@/components/hero/SynapticText";

interface NeuralNodeLabelProps {
  agent: {
    title: string;
    category: string;
  };
  isInteractive: boolean;
  isMobile: boolean;
}

export const NeuralNodeLabel: React.FC<NeuralNodeLabelProps> = ({
  agent,
  isInteractive,
  isMobile
}) => {
  return (
    <div 
      className={`
        absolute top-full left-1/2 transform -translate-x-1/2 
        transition-all duration-300 pointer-events-none
        ${isInteractive ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}
        ${isMobile ? 'mt-2' : 'mt-4'}
      `}
    >
      <div className="text-center">
        <div className={`bg-black/90 backdrop-blur-sm border border-white/20 rounded-lg shadow-lg ${isMobile ? 'px-3 py-2 space-y-1' : 'px-2 py-1'}`}>
          <SynapticText 
            text={agent.title}
            className={`font-bold text-white mb-0 ${isMobile ? 'text-sm' : 'text-sm'}`}
            delay={0}
          />
          {isMobile && (
            <div className="text-xs text-white/80 font-medium">
              {agent.category}
            </div>
          )}
        </div>
        {!isMobile && (
          <div className="text-xs text-white bg-black/80 backdrop-blur-sm px-2 py-1 rounded mt-1">
            {agent.category}
          </div>
        )}
      </div>
    </div>
  );
};